import { launchPanelApp } from './lib/PanelApp';
import PreLoginLayout from './pages/layout/PreLoginLayout';

// Page specific code :
import Login from './pages/login/Login';

launchPanelApp(Login, {}, PreLoginLayout);
